<template>
  <div class="performance-overall-item">
    <div class="performance-overall-item__top">
      <icon
        class="performance-overall-item__icon"
        :name="iconName"
      />
      <div class="content__title">
        {{ title }}
      </div>
    </div>
    <div class="content__value">
      {{ value }}
    </div>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  components: { Icon },
  props: {
    iconName: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: 'Title',
    },
    value: {
      type: String,
      default: 'Value',
    },
  },
};
</script>

<style lang="scss" scoped>
.performance-overall-item {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  align-self: stretch;
  gap: var(--spacing-md);
}

.performance-overall-item__top {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  min-width: 0;
}

.performance-overall-item__icon {
  flex-shrink: 0;
  width: rem-calc(20);
  height: rem-calc(20);
  object-fit: contain;
}

.content__title {
  font-family: var(--Fontfamilyfont-family-body);
  font-size: var(--Fontsizetext-md);
  font-weight: var(--Fontweightfont-weight-medium);
  line-height: var(--Lineheighttext-md);
  color: var(--text-primary);
}

.content__value {
  font-family: var(--Fontfamilyfont-family-body);
  font-size: rem-calc(20);
  font-weight: var(--Fontweightfont-weight-semibold);
  line-height: 1;
  color: var(--text-primary-900);
}
</style>
